import styled from 'styled-components';
import { Card, Tag } from 'antd';

// 页面容器
export const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
  padding: 24px;
  
  @media (max-width: 768px) {
    padding: 16px;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  background: #ffffff;
  border-radius: 24px;
  padding: 40px;
  box-shadow: 0 20px 80px rgba(0,0,0,0.08);
  border: 1px solid #e2e8f0;
  
  @media (max-width: 768px) {
    padding: 24px;
    border-radius: 16px;
  }
`;

// 分类卡片
export const StyledCard = styled(Card)`
  border-radius: 20px !important;
  box-shadow: 0 4px 16px rgba(0,0,0,0.08);
  border: none !important;
  background: #ffffff !important;
  font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
  position: relative;
  will-change: transform, box-shadow;
  
  .ant-card-body {
    position: relative;
    z-index: 2;
  }
  
  .ant-card-meta-title {
    font-weight: 600;
    font-size: 1.1rem;
    letter-spacing: -0.02em;
    color: #1a202c;
    font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif;
  }
  .ant-card-meta-description {
    color: #64748b;
    font-size: 0.9rem;
    font-weight: 400;
    font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif;
  }
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(0,0,0,0.15);
    border: 1px solid rgba(99, 102, 241, 0.2);
  }
`;

// 筛选栏
export const FilterBar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin: 48px 0 32px 0;
  padding: 24px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 16px rgba(0,0,0,0.04);
  align-items: flex-start;
  font-size: 16px;
`;

export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  width: 100%;

  @media (max-width: 600px) {
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 12px;
    white-space: nowrap;
    width: 100%;
    & > * {
      flex-shrink: 0;
    }
  }
`;

export const FilterLabel = styled.span`
  min-width: 60px;
  color: #374151;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: -0.01em;
`;

export const FilterTag = styled(Tag.CheckableTag)`
  font-size: 14px;
  padding: 8px 16px;
  border-radius: 20px !important;
  margin-right: 8px;
  margin-bottom: 4px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  color: #64748b;
  font-weight: 500;
  transition: all 0.2s ease-out;
  will-change: transform, border-color, color;
  
  &:hover {
    border-color: #6366f1;
    color: #6366f1;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.15);
  }
  
  &.ant-tag-checkable-checked {
    background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%) !important;
    color: #ffffff !important;
    border-color: transparent !important;
    box-shadow: 0 4px 16px rgba(99, 102, 241, 0.3);
  }
`;

// 分类容器
export const CardSection = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-bottom: 32px;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`;

// 推荐装备网格容器
export const RecommendGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-bottom: 32px;
  
  @media (max-width: 1350px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 992px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }
`;

// 推荐区域
export const RecommendSection = styled.div`
  margin: 48px 0;
  padding: 32px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 32px rgba(0,0,0,0.06);
  
  .ant-typography h3 {
    color: #1a202c;
    font-weight: 700;
    font-size: 24px;
    letter-spacing: -0.02em;
    font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif;
    text-align: center;
  }
`;

// 品牌区域
export const BrandSection = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  margin: 48px 0 0 0;
`;

// 新增：品牌展示区域
export const BrandShowcaseSection = styled.div`
  margin: 48px 0;
  padding: 32px;
  background: linear-gradient(135deg, #f8fafc 0%, #ffffff 100%);
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 8px 32px rgba(0,0,0,0.06);
`;

export const BrandShowcaseTitle = styled.h3`
  font-size: 24px;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 24px;
  text-align: center;
  letter-spacing: -0.02em;
  font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif;
`;

export const BrandGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
  max-width: 100%;
  
  @media (max-width: 1024px) {
    grid-template-columns: repeat(4, 1fr);
  }
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 16px;
  }

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const BrandCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 16px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s ease-out;
  position: relative;
  will-change: transform, box-shadow;
  
  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
    border-color: #6366f1;
  }
`;

export const BrandLogo = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 12px;
  filter: grayscale(0.3);
  transition: filter 0.2s ease-out;
  position: relative;
  z-index: 1;
  
  ${BrandCard}:hover & {
    filter: grayscale(0);
  }
`;

export const BrandName = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  text-align: center;
  letter-spacing: -0.01em;
  position: relative;
  z-index: 1;
  transition: color 0.2s ease-out;
  
  ${BrandCard}:hover & {
    color: #374151;
  }
`;

export const BrandList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding-right: 0;
  background: #ffffff;
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 16px rgba(0,0,0,0.04);
`;

export const AlphaIndex = styled.div`
  width: 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  user-select: none;
  position: sticky;
  top: 80px;
  background: #ffffff;
  border-radius: 16px;
  padding: 16px 8px;
  border: 1px solid #e2e8f0;
  box-shadow: 0 4px 16px rgba(0,0,0,0.04);
  margin-left: 16px;
`;

export const BrandGroupTitle = styled.div`
  font-weight: 700;
  font-size: 18px;
  margin: 16px 0 8px 0;
  color: #374151;
  letter-spacing: -0.01em;
`;

export const BrandItem = styled.div`
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 8px;
  margin-bottom: 4px;
  transition: all 0.2s ease;
  color: #64748b;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  
  &:hover {
    color: #6366f1;
    background: #f1f5f9;
    transform: translateX(4px);
  }
  
  img {
    width: 20px;
    height: 20px;
    object-fit: contain;
    flex-shrink: 0;
  }
`;

export const CardImage = styled.img`
  height: 160px;
  width: 100%;
  object-fit: contain;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  display: block;
  border-radius: 16px;
  transition: all 0.3s ease;
  
  ${StyledCard}:hover & {
    transform: scale(1.05);
  }
`;

// 页脚组件
export const Footer = styled.div`
  margin-top: 64px;
  padding: 24px 0 32px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Inter', 'SF Pro Display', 'Alibaba PuHuiTi', 'Arial', sans-serif;
  
  .beian-info {
    a {
      display: flex;
      align-items: center;
      color: #94a3b8;
      text-decoration: none;
      font-size: 13px;
      transition: all 0.2s ease;
      
      &:hover {
        color: #64748b;
        
        img {
          opacity: 1;
        }
      }
      
      img {
        width: 16px;
        height: 16px;
        margin-right: 6px;
        opacity: 0.8;
        transition: opacity 0.2s ease;
        object-fit: contain;
      }
    }
  }
  
  .version-info {
    font-size: 12px;
    color: #cbd5e1;
    font-family: monospace;
    user-select: none;
  }

  @media (max-width: 640px) {
    flex-direction: column;
    gap: 16px;
    padding-bottom: 48px;
    
    .version-info {
      order: 2;
    }
  }
`;